export default __webpack_public_path__ + "images/SpeakersPhotos/Daniel_Puertolas_Numericco.jpg?36f20f70";